import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    // 根據要求設定特定的登入憑據
    if (login === 'Admin' && password === 'leonie') {
      setError('');
      navigate('/accounting/bind');
    } else {
      setError('Invalid login or password.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 font-sans">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-[400px] border border-gray-200">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#0000a0]">WY Limited</h1>
          <div className="h-1 w-16 bg-[#0000a0] mx-auto mt-2"></div>
          <h2 className="text-gray-500 mt-6 uppercase tracking-widest text-sm font-semibold">Login to System</h2>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          {error && (
            <div className="bg-red-50 border-l-4 border-red-500 p-3 text-red-700 text-xs">
              {error}
            </div>
          )}

          <div>
            <label className="block text-xs font-bold text-gray-700 mb-1 uppercase">Login Name</label>
            <input 
              type="text" 
              className="w-full border border-gray-300 p-2.5 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all" 
              placeholder="Enter your username"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-700 mb-1 uppercase">Password</label>
            <input 
              type="password" 
              className="w-full border border-gray-300 p-2.5 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all" 
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="pt-2">
            <button 
              type="submit" 
              className="w-full bg-[#0000a0] text-white py-2.5 rounded hover:bg-blue-900 transition duration-200 font-bold uppercase tracking-wider shadow-md text-sm"
            >
              Login
            </button>
          </div>
        </form>

        <div className="mt-8 text-center text-[10px] text-gray-400">
          © 2026 WY Limited. All rights reserved.
        </div>
      </div>
    </div>
  );
}